import React, { Component } from "react"
import { Link } from "react-router-dom"
import ApptitudeLogo from "assets/icons/loader-logo.svg"
// Import Styles
import "./index.scss"

export class Footer extends Component {
  isLinkedin = (data) => {
    return data === "linked_in" ? "linkedin" : data
  }
  render() {
    const { data, socials } = this.props
    return (
      <footer className="page-footer">
        <nav className="footer-wrapper">
          <div className="logo-container">
            <img
              className="image"
              src={data.logo}
              alt={data.name}
              width="112"
              height="80"
            />
          </div>
          <div className="footer-section">
            <p className="title">Headquarters</p>
            <p className="text">
              <span className="icon-location" />
              {data.address}
            </p>
          </div>
          <div className="footer-section">
            <p className="title">Contact Us</p>
            <p className="text">
              <span className="icon-phone" />
              {data.phone_number}
            </p>
            <p className="text">
              <span className="icon-mobile" />
              {data.country_code}
              {data.mobile_number}
            </p>
            <p className="text">
              <span className="icon-email" />
              {data.email}
            </p>
          </div>
          <div className="footer-section">
            {socials && socials.length ? (
              <>
                <p className="title">Connect With Us</p>
                <div className="social-container">
                  {socials.map((item) =>
                    item.url ? (
                      <Link
                        key={item.id}
                        to={{
                          pathname: `${item.value}${item.url}`,
                        }}
                        target="_blank"
                      >
                        <span className="icon has-text-dark">
                          <i
                            className={`fab fa-${this.isLinkedin(
                              item.label
                            )} fa-lg`}
                          ></i>
                        </span>
                      </Link>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </>
            ) : null}
            <p className="title">Copyright © 2022</p>
            <div className="powered-by">
              <p className="label">Powered By</p>
              <img className="app-logo" src={ApptitudeLogo} alt="alt" />
            </div>
          </div>
        </nav>
      </footer>
    )
  }
}

export default Footer
